import storage from "store";
import {ACCESS_TOKEN, PARENT_URL} from "@/store/mutation-types";
import {loadUserInfo} from "@/api/account";

const user = {
    state: {
        userInfo: {}
    },
    mutations: {
        SET_USER_INFO: (state, info) => {
            state.userInfo = info
        }
    },
    actions: {
        Kickout({commit}) {
            storage.remove(ACCESS_TOKEN)
            commit('SET_USER_INFO', {})
            window.open(storage.get(PARENT_URL), '_self')
        },
        loadUser ({commit}) {
            loadUserInfo().then(res => {
                commit('SET_USER_INFO', res.data)
            })
        }
    }
}

export default user
